var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaystore6Ad748031(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 189,
    height: 56,
    viewBox: "0 0 189 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_571_156)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M182.5 0.649902H6.4999C3.26904 0.649902 0.649902 3.26904 0.649902 6.4999V49.4999C0.649902 52.7308 3.26904 55.3499 6.4999 55.3499H182.5C185.731 55.3499 188.35 52.7308 188.35 49.4999V6.4999C188.35 3.26904 185.731 0.649902 182.5 0.649902Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.5 0.649902H6.4999C3.26904 0.649902 0.649902 3.26904 0.649902 6.4999V49.4999C0.649902 52.7308 3.26904 55.3499 6.4999 55.3499H182.5C185.731 55.3499 188.35 52.7308 188.35 49.4999V6.4999C188.35 3.26904 185.731 0.649902 182.5 0.649902Z",
    stroke: "#A6A6A6",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_571_156)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6106 10.5529C14.2032 10.9841 13.9624 11.6533 13.9624 12.5199V43.4823C13.9624 44.3503 14.2032 45.0181 14.6106 45.4493L14.7142 45.5501L32.0588 28.2055V28.0011V27.7967L14.7142 10.4507L14.6106 10.5529Z",
    fill: "url(#paint0_linear_571_156)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8392 33.9888L32.0586 28.2054V28.001V27.7966L37.8406 22.0146L37.9708 22.0888L44.821 25.9808C46.7768 27.0924 46.7768 28.911 44.821 30.024L37.9708 33.916L37.8392 33.9888Z",
    fill: "url(#paint1_linear_571_156)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_571_156)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.9712 33.9146L32.0576 28.001L14.6108 45.4492C15.2548 46.1324 16.3202 46.2164 17.52 45.536L37.9712 33.9146Z",
    fill: "url(#paint2_linear_571_156)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M37.9712 22.0876L17.52 10.4676C16.3202 9.78577 15.2548 9.87117 14.6108 10.5544L32.0589 28.0026L37.9712 22.0876Z",
    fill: "url(#paint3_linear_571_156)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M95.3901 30.4518C92.0973 30.4518 89.4135 32.9564 89.4135 36.406C89.4135 39.8346 92.0973 42.3602 95.3901 42.3602C98.6843 42.3602 101.368 39.8346 101.368 36.406C101.367 32.9564 98.6829 30.4518 95.3901 30.4518ZM95.3901 40.0166C93.5855 40.0166 92.0301 38.5284 92.0301 36.4074C92.0301 34.264 93.5869 32.7982 95.3901 32.7982C97.1947 32.7982 98.7501 34.264 98.7501 36.4074C98.7501 38.527 97.1947 40.0166 95.3901 40.0166ZM82.3505 30.4518C79.0577 30.4518 76.3739 32.9564 76.3739 36.406C76.3739 39.8346 79.0577 42.3602 82.3505 42.3602C85.6447 42.3602 88.3285 39.8346 88.3285 36.406C88.3285 32.9564 85.6447 30.4518 82.3505 30.4518ZM82.3505 40.0166C80.5459 40.0166 78.9905 38.5284 78.9905 36.4074C78.9905 34.264 80.5473 32.7982 82.3505 32.7982C84.1551 32.7982 85.7105 34.264 85.7105 36.4074C85.7119 38.527 84.1551 40.0166 82.3505 40.0166ZM66.8413 32.2802V34.8058H72.8865C72.7059 36.2268 72.2327 37.2642 71.5103 37.9852C70.6311 38.8644 69.2549 39.8346 66.8413 39.8346C63.1201 39.8346 60.2109 36.8344 60.2109 33.1132C60.2109 29.392 63.1201 26.3918 66.8413 26.3918C68.8489 26.3918 70.3147 27.1814 71.3969 28.1964L73.1791 26.4142C71.6671 24.9708 69.6609 23.8662 66.8413 23.8662C61.7439 23.8662 57.4585 28.0158 57.4585 33.1132C57.4585 38.2106 61.7439 42.3602 66.8413 42.3602C69.5923 42.3602 71.6685 41.4572 73.2911 39.766C74.9599 38.0972 75.4793 35.7508 75.4793 33.8566C75.4793 33.2714 75.4345 32.7296 75.3435 32.2788H66.8413V32.2802ZM130.273 34.2416C129.777 32.9116 128.265 30.4518 125.175 30.4518C122.108 30.4518 119.559 32.8654 119.559 36.406C119.559 39.7436 122.086 42.3602 125.468 42.3602C128.197 42.3602 129.776 40.6914 130.431 39.7212L128.401 38.3674C127.725 39.36 126.799 40.0138 125.468 40.0138C124.138 40.0138 123.19 39.4048 122.581 38.2092L130.543 34.9164L130.273 34.2416ZM122.153 36.2268C122.086 33.9252 123.935 32.7534 125.266 32.7534C126.304 32.7534 127.183 33.2728 127.477 34.0162L122.153 36.2268ZM115.681 42.0004H118.296V24.499H115.681V42.0004ZM111.394 31.7832H111.304C110.718 31.0832 109.589 30.4518 108.17 30.4518C105.192 30.4518 102.463 33.0684 102.463 36.4298C102.463 39.7674 105.192 42.3616 108.17 42.3616C109.591 42.3616 110.718 41.7302 111.304 41.0092H111.394V41.866C111.394 44.1438 110.176 45.3618 108.214 45.3618C106.613 45.3618 105.62 44.2124 105.214 43.2422L102.936 44.19C103.59 45.7678 105.326 47.7082 108.214 47.7082C111.282 47.7082 113.876 45.9036 113.876 41.5048V30.8144H111.395L111.394 31.7832ZM108.395 40.0166C106.59 40.0166 105.08 38.5046 105.08 36.4298C105.08 34.3312 106.59 32.7982 108.395 32.7982C110.176 32.7982 111.574 34.3312 111.574 36.4298C111.574 38.5046 110.176 40.0166 108.395 40.0166ZM142.528 24.499H136.269V42.0004H138.88V35.37H142.527C145.422 35.37 148.27 33.2742 148.27 29.9352C148.27 26.5962 145.424 24.499 142.528 24.499ZM142.596 32.934H138.88V26.935H142.596C144.549 26.935 145.657 28.552 145.657 29.9352C145.657 31.2904 144.549 32.934 142.596 32.934ZM158.74 30.421C156.849 30.421 154.89 31.254 154.08 33.1006L156.398 34.068C156.894 33.1006 157.818 32.7842 158.785 32.7842C160.136 32.7842 161.51 33.5948 161.532 35.0354V35.216C161.059 34.9458 160.045 34.5412 158.808 34.5412C156.309 34.5412 153.763 35.9146 153.763 38.4808C153.763 40.823 155.813 42.3308 158.109 42.3308C159.865 42.3308 160.833 41.5426 161.441 40.6186H161.531V41.9696H164.053V35.2594C164.055 32.1542 161.734 30.421 158.74 30.421ZM158.424 40.0124C157.57 40.0124 156.376 39.584 156.376 38.5256C156.376 37.1746 157.863 36.6566 159.146 36.6566C160.293 36.6566 160.835 36.9044 161.532 37.2418C161.329 38.8644 159.933 40.0124 158.424 40.0124ZM173.24 30.8032L170.246 38.3912H170.156L167.048 30.8032H164.234L168.895 41.4082L166.237 47.3078H168.962L176.145 30.8032H173.24ZM149.712 42.0004H152.323V24.499H149.712V42.0004Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.385 14.3399C66.385 15.5131 66.0378 16.4469 65.342 17.1441C64.5524 17.9729 63.522 18.3873 62.2564 18.3873C61.044 18.3873 60.0122 17.9673 59.1652 17.1273C58.3168 16.2859 57.8926 15.2443 57.8926 14.0011C57.8926 12.7565 58.3168 11.7149 59.1652 10.8749C60.0122 10.0335 61.044 9.61353 62.2564 9.61353C62.8584 9.61353 63.4338 9.73112 63.9798 9.96492C64.5272 10.2001 64.9654 10.5123 65.293 10.9029L64.5552 11.6421C63.9994 10.9771 63.2336 10.6453 62.255 10.6453C61.3702 10.6453 60.6058 10.9561 59.9604 11.5777C59.315 12.1993 58.993 13.0071 58.993 13.9997C58.993 14.9923 59.315 15.8001 59.9604 16.4217C60.6058 17.0433 61.3702 17.3541 62.255 17.3541C63.193 17.3541 63.9756 17.0419 64.6014 16.4161C65.0074 16.0087 65.2426 15.4417 65.3056 14.7151H62.255V13.7057H66.3248C66.3668 13.9255 66.385 14.1369 66.385 14.3399Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8393 10.8317H69.0145V13.4945H72.4641V14.5039H69.0145V17.1667H72.8393V18.1999H67.9351V9.7998H72.8393V10.8317Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.3906 18.1999H76.3112V10.8317H73.9648V9.7998H79.737V10.8317H77.3906V18.1999Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.9131 18.1999V9.7998H84.9925V18.1999H83.9131Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.7793 18.1999H88.6999V10.8317H86.3535V9.7998H92.1257V10.8317H89.7793V18.1999Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.052 17.1148C102.226 17.9632 101.2 18.3874 99.9725 18.3874C98.7447 18.3874 97.7185 17.9632 96.8939 17.1148C96.0679 16.2664 95.6562 15.2276 95.6562 13.9998C95.6562 12.772 96.0679 11.7332 96.8939 10.8848C97.7185 10.0364 98.7447 9.61084 99.9725 9.61084C101.193 9.61084 102.218 10.0378 103.047 10.8904C103.876 11.743 104.29 12.779 104.29 13.9998C104.29 15.2276 103.877 16.2664 103.052 17.1148ZM97.6905 16.4106C98.3121 17.0406 99.0723 17.3542 99.9725 17.3542C100.873 17.3542 101.634 17.0392 102.254 16.4106C102.876 15.7806 103.188 14.977 103.188 13.9998C103.188 13.0226 102.876 12.219 102.254 11.589C101.634 10.959 100.873 10.6454 99.9725 10.6454C99.0723 10.6454 98.3121 10.9604 97.6905 11.589C97.0703 12.219 96.7581 13.0226 96.7581 13.9998C96.7581 14.977 97.0703 15.7806 97.6905 16.4106Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.805 18.1999V9.7998H107.118L111.2 16.3337H111.247L111.2 14.7153V9.7998H112.28V18.1999H111.153L106.881 11.3483H106.835L106.881 12.9667V18.1999H105.805Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.385 14.3399C66.385 15.5131 66.0378 16.4469 65.342 17.1441C64.5524 17.9729 63.522 18.3873 62.2564 18.3873C61.044 18.3873 60.0122 17.9673 59.1652 17.1273C58.3168 16.2859 57.8926 15.2443 57.8926 14.0011C57.8926 12.7565 58.3168 11.7149 59.1652 10.8749C60.0122 10.0335 61.044 9.61353 62.2564 9.61353C62.8584 9.61353 63.4338 9.73112 63.9798 9.96492C64.5272 10.2001 64.9654 10.5123 65.293 10.9029L64.5552 11.6421C63.9994 10.9771 63.2336 10.6453 62.255 10.6453C61.3702 10.6453 60.6058 10.9561 59.9604 11.5777C59.315 12.1993 58.993 13.0071 58.993 13.9997C58.993 14.9923 59.315 15.8001 59.9604 16.4217C60.6058 17.0433 61.3702 17.3541 62.255 17.3541C63.193 17.3541 63.9756 17.0419 64.6014 16.4161C65.0074 16.0087 65.2426 15.4417 65.3056 14.7151H62.255V13.7057H66.3248C66.3668 13.9255 66.385 14.1369 66.385 14.3399Z",
    stroke: "white",
    strokeWidth: 0.26,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8393 10.8317H69.0145V13.4945H72.4641V14.5039H69.0145V17.1667H72.8393V18.1999H67.9351V9.7998H72.8393V10.8317Z",
    stroke: "white",
    strokeWidth: 0.26,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.3906 18.1999H76.3112V10.8317H73.9648V9.7998H79.737V10.8317H77.3906V18.1999Z",
    stroke: "white",
    strokeWidth: 0.26,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.9131 18.1999V9.7998H84.9925V18.1999H83.9131Z",
    stroke: "white",
    strokeWidth: 0.26,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.7793 18.1999H88.6999V10.8317H86.3535V9.7998H92.1257V10.8317H89.7793V18.1999Z",
    stroke: "white",
    strokeWidth: 0.26,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.052 17.1148C102.226 17.9632 101.2 18.3874 99.9725 18.3874C98.7447 18.3874 97.7185 17.9632 96.8939 17.1148C96.0679 16.2664 95.6562 15.2276 95.6562 13.9998C95.6562 12.772 96.0679 11.7332 96.8939 10.8848C97.7185 10.0364 98.7447 9.61084 99.9725 9.61084C101.193 9.61084 102.218 10.0378 103.047 10.8904C103.876 11.743 104.29 12.779 104.29 13.9998C104.29 15.2276 103.877 16.2664 103.052 17.1148ZM97.6905 16.4106C98.3121 17.0406 99.0723 17.3542 99.9725 17.3542C100.873 17.3542 101.634 17.0392 102.254 16.4106C102.876 15.7806 103.188 14.977 103.188 13.9998C103.188 13.0226 102.876 12.219 102.254 11.589C101.634 10.959 100.873 10.6454 99.9725 10.6454C99.0723 10.6454 98.3121 10.9604 97.6905 11.589C97.0703 12.219 96.7581 13.0226 96.7581 13.9998C96.7581 14.977 97.0703 15.7806 97.6905 16.4106Z",
    stroke: "white",
    strokeWidth: 0.26,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.805 18.1999V9.7998H107.118L111.2 16.3337H111.247L111.2 14.7153V9.7998H112.28V18.1999H111.153L106.881 11.3483H106.835L106.881 12.9667V18.1999H105.805Z",
    stroke: "white",
    strokeWidth: 0.26,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_571_156",
    x: 13.9624,
    y: 9.80207,
    width: 32.3257,
    height: 36.3988,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.195
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_571_156"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.195
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_571_156",
    result: "effect2_dropShadow_571_156"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_571_156",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_571_156",
    x: 14.6108,
    y: 27.806,
    width: 23.3604,
    height: 18.1999,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.195
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_571_156"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_571_156",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_571_156",
    x1: 30.5213,
    y1: 12.1923,
    x2: 7.02648,
    y2: 35.6871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0066,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_571_156",
    x1: 47.3669,
    y1: 28.001,
    x2: 13.4927,
    y2: 28.001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_571_156",
    x1: 34.7597,
    y1: 31.2124,
    x2: 2.89784,
    y2: 63.0743,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_571_156",
    x1: 10.2167,
    y1: 0.247288,
    x2: 24.4439,
    y2: 14.4745,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_571_156"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 189,
    height: 56,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaystore6Ad748031);
export default __webpack_public_path__ + "static/media/playstore-6ad74803 1.1e36ef02b50038f89b1b509dbf4d1d21.svg";
export { ForwardRef as ReactComponent };